export const compactNumberFormatter = (value: number | bigint) =>
  new Intl.NumberFormat('en', { notation: 'compact', compactDisplay: 'short' }).format(value);
